<ng-container rtBlock="sc-about-page">
    <sc-page-header>
        <h1 slot="title" i18n="@@navAboutProject">О проекте</h1>
        <p slot="lead" rtElem="lead">
            <b i18n="@@aboutHeroSideStrong">Почему GoldenCalc.</b>
            <span i18n="@@aboutHeroSide1">
                Частный застройщик не должен осваивать Autodesk, чтобы проверить геометрию лестницы. Мастерская не должна держать штатного
                инженера для предварительного расчёта. Мы сделали инструмент, который покрывает 95% бытовых сценариев и работает прямо в
                браузере.
            </span>
        </p>
    </sc-page-header>

    @if (false) {
        <section rtElem="stats">
            <div rtElem="stats-cell">
                <div rtElem="stats-label" i18n="@@aboutStat1Label">Запущен</div>
                <div rtElem="stats-value">2025</div>
                <p rtElem="stats-text" i18n="@@aboutStat1Text">Первая публичная версия — октябрь 2025.</p>
            </div>
            <div rtElem="stats-cell">
                <div rtElem="stats-label" i18n="@@aboutStat2Label">Расчётов</div>
                <div rtElem="stats-value">
                    {{ calcCount() }}
                    <small i18n="@@aboutStat2Suffix">/мес</small>
                </div>
                <p rtElem="stats-text">
                    <span i18n="@@aboutStat2TextPrefix">Уникальных сессий за</span>
                    {{ monthYear() }}.
                </p>
            </div>
            <div rtElem="stats-cell">
                <div rtElem="stats-label" i18n="@@aboutStat3Label">Нормативы</div>
                <div rtElem="stats-value">
                    2
                    <small i18n="@@aboutStat3Suffix">источн.</small>
                </div>
                <p rtElem="stats-text" i18n="@@aboutStat3Text">СП 54.13330.2022 и формула Блонделя.</p>
            </div>
            <div rtElem="stats-cell">
                <div rtElem="stats-label" i18n="@@aboutStat4Label">Бэкенд</div>
                <div rtElem="stats-value">
                    0
                    <small i18n="@@aboutStat4Suffix">kb</small>
                </div>
                <p rtElem="stats-text" i18n="@@aboutStat4Text">Полностью клиентское приложение.</p>
            </div>
        </section>
    }

    <section rtElem="story">
        <div rtElem="story-l">
            <p rtElem="story-h3" i18n="@@aboutStoryKicker">История</p>
            <h2 rtElem="story-h2">
                <span i18n="@@aboutStoryTitleA">Начиналось</span>
                <em i18n="@@aboutStoryTitleEm">с одной</em>
                <span i18n="@@aboutStoryTitleB">лестницы.</span>
            </h2>
        </div>
        <div rtElem="story-r">
            <p rtElem="story-p" i18n="@@aboutStoryP1">
                Однажды три отличных опытных инженера с высшим образованием (Максим, Евгений и Святослав) собрались вместе, чтобы создать
                лучший в мире строительный калькулятор GoldenCalc.
            </p>
            <p rtElem="story-p" i18n="@@aboutStoryP2">Основных причин несколько:</p>
            <p rtElem="story-p" i18n="@@aboutStoryP3">
                1. Не было ни одного подходящего простого калькулятора, с которым можно было работать не имея серьёзных знаний в
                строительной сфере. Либо не имея опыта работы со специализированными программами. Наш же калькулятор учитывает все
                оптимальные параметры и соответствие итогового изделия СНиП (Строительные нормы и правила).
            </p>
            <p rtElem="story-p" i18n="@@aboutStoryP4">
                2. Все калькуляторы, которые выдают хоть какие-то реальные параметры и данные, и благодаря которым действительно можно
                реализовать удобное и качественное изделие, требуют обязательной платной регистрации и подписки. Мы же зарабатываем на
                рекламе местных производителей (после расчёта лестницы у Вас будет возможность отправить её на просчёт только проверенным
                производителям для детального расчёта в Вашем регионе, а также изучить только актуальные отзывы).
            </p>
            <p rtElem="story-p" i18n="@@aboutStoryP5">
                3. Весь расчёт сопровождается ссылками на дополнительную информацию и статьи. Что позволяет даже при первом построении
                лестницы достаточно детально и легко вникнуть в данную строительную сферу. В перспективе планируется добавление таких
                данных, которые позволят каждому человеку даже создать собственное производство с нуля.
            </p>
            <p rtElem="story-p" i18n="@@aboutStoryP6">
                4. Данный калькулятор также будет актуальным для застройщиков, архитекторов, дизайнеров и прорабов. Он позволит очень быстро
                согласовать проект с заказчиком, а также найти ответственных и проверенных подрядчиков.
            </p>
            <p rtElem="story-p" i18n="@@aboutStoryP7">
                На сегодняшний день GoldenCalc — это четыре типа лестниц, шесть пород дерева, три доменные зоны. Всё, что мы обещаем в 2025
                году, — бесплатно, без регистрации и без установки специфических программ.
            </p>
        </div>
    </section>

    @if (false) {
        <section rtElem="timeline">
            <h3 rtElem="timeline-h3">
                <span i18n="@@aboutTimelineHeadA">Что</span>
                <em i18n="@@aboutTimelineHeadEm">дальше</em>
            </h3>
            <div rtElem="timeline-grid">
                <div rtElem="timeline-step">
                    <div rtElem="timeline-date" i18n="@@aboutTimelineDate1">Q4 2025 — now</div>
                    <h4 rtElem="timeline-h4" i18n="@@aboutTimelineTitle1">SEO-фундамент</h4>
                    <p rtElem="timeline-p" i18n="@@aboutTimelineText1">Legal-страницы, пять SEO-посадочных, Angular Router.</p>
                </div>
                <div rtElem="timeline-step">
                    <div rtElem="timeline-date" i18n="@@aboutTimelineDate2">Q1 2026</div>
                    <h4 rtElem="timeline-h4" i18n="@@aboutTimelineTitle2">Фаза монетизации</h4>
                    <p rtElem="timeline-p" i18n="@@aboutTimelineText2">/for-business, CPL-лиды для мастерских.</p>
                </div>
                <div rtElem="timeline-step">
                    <div rtElem="timeline-date" i18n="@@aboutTimelineDate3">Q2 2026</div>
                    <h4 rtElem="timeline-h4" i18n="@@aboutTimelineTitle3">SEO-экспансия</h4>
                    <p rtElem="timeline-p" i18n="@@aboutTimelineText3">Страницы пород дерева, блог, гео-посадочные.</p>
                </div>
                <div rtElem="timeline-step">
                    <div rtElem="timeline-date" i18n="@@aboutTimelineDate4">Q3 2026</div>
                    <h4 rtElem="timeline-h4" i18n="@@aboutTimelineTitle4">API</h4>
                    <p rtElem="timeline-p" i18n="@@aboutTimelineText4">Публичное API расчётов для партнёров.</p>
                </div>
                <div rtElem="timeline-step">
                    <div rtElem="timeline-date" i18n="@@aboutTimelineDate5">Q4 2026</div>
                    <h4 rtElem="timeline-h4" i18n="@@aboutTimelineTitle5">White-label</h4>
                    <p rtElem="timeline-p" i18n="@@aboutTimelineText5">Встраиваемый виджет в сайты производителей.</p>
                </div>
            </div>
        </section>
    }

    <section rtElem="cta">
        <h2 rtElem="cta-h2">
            <span i18n="@@aboutCtaTitleA">Напишите —</span>
            <br />
            <em i18n="@@aboutCtaTitleEm">или просто</em>
            <span i18n="@@aboutCtaTitleB">считайте.</span>
        </h2>
        <a rtElem="cta-btn" routerLink="/calc/straight" i18n="@@aboutCtaButtonOpen">Открыть конструктор →</a>
        <a rtElem="cta-btn" routerLink="/contacts" i18n="@@aboutCtaButtonContacts" [rtMod]="{ ghost: true }">Контакты</a>
    </section>
</ng-container>
